import { render, staticRenderFns } from "./DnsRecordModal.vue?vue&type=template&id=811b0b9c"
import script from "./DnsRecordModal.vue?vue&type=script&lang=js"
export * from "./DnsRecordModal.vue?vue&type=script&lang=js"
import style0 from "./DnsRecordModal.vue?vue&type=style&index=0&id=811b0b9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports